import script from "./NodeImage.vue?vue&type=script&setup=true&lang=js"
export * from "./NodeImage.vue?vue&type=script&setup=true&lang=js"

import "./NodeImage.vue?vue&type=style&index=0&id=0fae5cbf&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fae5cbf"]])

export default __exports__